import ShowerHeadSvg from '@assets/images/svg/shower-head.svg';
import React from 'react';
import { View } from 'react-native';

export interface ShowerHeadIconProps {
    size?: number;
    color?: string;
}

export function ShowerHeadIcon({ size = 20, color = '#333333' }: ShowerHeadIconProps) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <ShowerHeadSvg width={size} height={size} color={color} />
        </View>
    );
}

export default ShowerHeadIcon;
